import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DecipherMappingActions } from './decipher-mapping.actions';
import { QuestionMapping } from './decipher-mapping-state.model';

@Injectable({ providedIn: 'root' })
export class DecipherMappingActionsFacade {
  private readonly _store = inject(Store);

  public load(cmp: number): void {
    this._store.dispatch(DecipherMappingActions.load({ cmp }));
  }

  public save(cmp: number, locale: string, mappings: QuestionMapping[]): void {
    this._store.dispatch(
      DecipherMappingActions.save({ cmp, locale, mappings }),
    );
  }
}
